<template>
    <div v-if="getModalConfirmationMccAccounts.show"
         :class="['ap2-modal ap2-modal-xs ap2-modal-content-center ap2-modal-two-options', getModalConfirmationMccAccounts.show ? 'open': null]"
         id="confirmation-modal-mcc">
        <div class="modal-wrapper ">
            <div class="ap2-modal-header">
                <div class="modal-header-title-wrapper">
                    <div class="modal-header-reference">
                        {{ getModalConfirmationMccAccounts.origin }}
                    </div>
                    <div class="modal-header-title text-capitalize">
                        Delete MCC Account
                    </div>
                </div>

                <div class="modal-header-close close-modal-demo">
                    <svg @click="close()"
                         height="1em"
                         viewBox="0 0 384 512"
                         xmlns="http://www.w3.org/2000/svg">
                        <path class="svg-fill"
                              d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                    </svg>
                </div>
            </div>
            <div class="ap2-modal-content" id="modal-confirmation">
                <div class="warning-image"
                     :style="{'-webkit-mask': 'url(' + danger + ')', '-webkit-mask-repeat': 'no-repeat', '-webkit-mask-position': 'center'}"></div>
                <div class="modal-headline">
                    To delete {{ getModalConfirmationMccAccounts.action }} master account you must delete the following accounts before:
                </div>
                <p v-for="account in getModalConfirmationMccAccounts.items"
                   :key="account.identifier"
                   class="modal-text"> {{ account.name }} </p>

            </div>
            <div class="ap2-modal-footer modal-controls" style="z-index: 11;">
                <div class="modal-controls">
                    <button type="button" class="ap2-btn btn btn-primary close-modal-demo"
                            @click="close()">
                        Ok
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
import danger from "@/assets/images/triangle-exclamation-solid.svg"

export default {
    name: "modalConfirmationMccAccounts",
    computed: {
        ...mapGetters(['getModalConfirmationMccAccounts']),
    },
    data() {
        return {
            danger: danger,
        }
    },
    methods: {
         close() {
            _.set(this.getModalConfirmationMccAccounts, 'show', false);
            _.set(this.getModalConfirmationMccAccounts, 'items', []);
            _.set(this.getModalConfirmationMccAccounts, 'origin', null);
            _.set(this.getModalConfirmationMccAccounts, 'action', null);
        },
    }
}
</script>

<style scoped>

</style>